export interface SitesDictionary {
  domain: string;
  description: string;
}

export const brandSites: SitesDictionary[] = [
  {
    domain: 'https://www.aceable.com/',
    description: 'Aceable',
  },
  {
    domain: 'https://www.aceableagent.com/',
    description: 'AceableAgent',
  },
  {
    domain: 'https://insurance.aceable.com/',
    description: 'Insurance',
  },
  {
    domain: 'https://mortgage.aceable.com/',
    description: 'Mortgage',
  },
  // EPS-4414 (Copilot review finding): ins's (and this hsp copy's) footer-data.ts link to
  // 'https://www.mortgage.aceable.com/' (with www), which doesn't exact-match the bare
  // domain above in AccessibilityService.getSiteDescription() — producing an empty aria
  // label/context for that link. Adding the www form so both resolve to "Mortgage".
  {
    domain: 'https://www.mortgage.aceable.com/',
    description: 'Mortgage',
  },
  {
    domain: 'https://hospitality.aceable.com/',
    description: 'Hospitality',
  },
];
